export interface Animal {
  id: number;
  nom: string;
  espece: string;
  description: string;
  image: string;
  zoneId: number;
}

export interface Zone {
  id: number;
  nom: string;
  description: string;
  image: string;
}

export interface Evenement {
  id: number;
  titre: string;
  date: string;
  description: string;
  image: string;
  places: number;
}

export interface Tarif {
  id: number;
  categorie: string;
  prix: number;
  description: string;
}

export const animaux: Animal[] = [
  {
    id: 1,
    nom: "Simba",
    espece: "Lion",
    description: "Majestueux lion d'Afrique, roi de la savane au Zoo Aventure. Admirez sa crinière impressionnante et son port noble lors de votre visite.",
    image: "https://images.unsplash.com/photo-1546182990-dffeafbe841d?w=800&auto=format&fit=crop",
    zoneId: 1
  },
  {
    id: 2,
    nom: "Luna",
    espece: "Loup arctique",
    description: "Luna est une louve arctique au pelage immaculé. Venez observer son comportement social fascinant dans son habitat naturel reconstitué.",
    image: "https://images.unsplash.com/photo-1607350999170-5100dbcd25c6?w=800&auto=format&fit=crop",
    zoneId: 1
  },
  {
    id: 3,
    nom: "Darwin",
    espece: "Tortue géante",
    description: "Darwin est l'une de nos plus anciennes habitantes. Cette tortue centenaire vous étonnera par sa longévité et son calme légendaire.",
    image: "https://images.unsplash.com/photo-1597162216923-ba6d99930c1b?w=800&auto=format&fit=crop",
    zoneId: 2
  },
  {
    id: 4,
    nom: "Bleu",
    espece: "Ara bleu",
    description: "Ce magnifique perroquet aux couleurs éclatantes vous surprendra par son intelligence et sa capacité à imiter les sons.",
    image: "https://images.unsplash.com/photo-1552728089-57bdde30beb3?w=800&auto=format&fit=crop",
    zoneId: 3
  },
  {
    id: 5,
    nom: "Nala",
    espece: "Girafe",
    description: "Avec ses 5 mètres de hauteur, Nala est l'animal le plus grand du zoo. Ne manquez pas le nourrissage quotidien à 14h.",
    image: "https://images.unsplash.com/photo-1547721064-da6cfb341d50?w=800&auto=format&fit=crop",
    zoneId: 1
  }
];

export const zones: Zone[] = [
  {
    id: 1,
    nom: "Savane Africaine",
    description: "Explorez les vastes étendues de la savane africaine et rencontrez ses habitants emblématiques : lions, girafes et zèbres.",
    image: "https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&auto=format&fit=crop"
  },
  {
    id: 2,
    nom: "Forêt Tropicale",
    description: "Plongez au cœur de la forêt tropicale humide, où vivent singes, perroquets et autres espèces extraordinaires.",
    image: "https://images.unsplash.com/photo-1536147116438-62679a5e01f2?w=800&auto=format&fit=crop"
  },
  {
    id: 3,
    nom: "Monde Aquatique",
    description: "Découvrez les mystères des océans et des rivières dans notre espace aquatique rénové.",
    image: "https://images.unsplash.com/photo-1544552866-9ba834af0f10?w=800&auto=format&fit=crop"
  }
];

export const evenements: Evenement[] = [
  {
    id: 1,
    titre: "Nuit au Zoo",
    date: "2025-05-15T20:00:00",
    description: "Vivez une expérience unique en passant la nuit au zoo. Découvrez les animaux nocturnes et leurs comportements fascinants.",
    image: "https://images.unsplash.com/photo-1503919005314-c3a034e8e052?w=800&auto=format&fit=crop",
    places: 30
  },
  {
    id: 2,
    titre: "Journée des Espèces Menacées",
    date: "2025-06-05T10:00:00",
    description: "Une journée spéciale dédiée à la sensibilisation et à la protection des espèces en voie de disparition.",
    image: "https://images.unsplash.com/photo-1551676874-a3d18265d119?w=800&auto=format&fit=crop",
    places: 100
  },
  {
    id: 3,
    titre: "Atelier Photo Animalière",
    date: "2025-05-25T14:00:00",
    description: "Apprenez les techniques de la photographie animalière avec notre photographe professionnel résident.",
    image: "https://images.unsplash.com/photo-1575550596614-bf620c75a83a?w=800&auto=format&fit=crop",
    places: 15
  }
];

export const tarifs: Tarif[] = [
  {
    id: 1,
    categorie: "Adulte",
    prix: 22,
    description: "Accès à toutes les zones du zoo"
  },
  {
    id: 2,
    categorie: "Enfant (3-12 ans)",
    prix: 15,
    description: "Accès à toutes les zones du zoo"
  },
  {
    id: 3,
    categorie: "Famille (2 adultes + 2 enfants)",
    prix: 65,
    description: "Pack économique familial"
  },
  {
    id: 4,
    categorie: "Senior (+65 ans)",
    prix: 18,
    description: "Accès à toutes les zones du zoo"
  }
];
